import * as React from 'react';
import {
  fetchNotifications,
  archiveNotifications,
  markNotificationsRead,
  getSignalrNegotiationResult,
} from '../../utils/api';
import { ApNotifications } from '@alixpartners/ui-components';

export interface IPayload {
  actionVerb: string | null;
  content: string;
  severity: string;
  shortName: string;
  timestamp: string;
  url: string | null;
}

export interface IDataItem {
  notificationId: string;
  payload: IPayload;
  state: string;
  type: string;
  userId: string;
}

interface IState {
  data: IDataItem[];
  notificationsUrl: string;
  notificationsAccessToken: string;
  notificationsIsFirstTimeConnection: boolean;
}

enum StateEnum {
  READ = 'Read',
  UNREAD = 'Unread',
}

enum TypeEnum {
  ACTION = 'Actionable',
  NORMAL = 'Normal',
}

export class Notifications extends React.Component<{}, IState> {
  public state = {
    data: [],
    notificationsUrl: '',
    notificationsAccessToken: '',
    notificationsIsFirstTimeConnection: true,
  };

  async componentDidMount() {
    const { url, accessToken } = await getSignalrNegotiationResult();
    this.setState({
      notificationsUrl: url,
      notificationsAccessToken: accessToken,
    });
  }

  getNotifications = () =>
    fetchNotifications()
      .then((data) =>
        this.setState({
          data: data || [],
        })
      )
      .catch((error) => {
        console.error(error);
      });

  markNotificationsAsRead = () => {
    const { data } = this.state;

    const normalUnreadNotifications = data
      .filter(
        (item: IDataItem) =>
          item.type === TypeEnum.NORMAL && item.state === StateEnum.UNREAD
      )
      .map((item: IDataItem) => item.notificationId);

    if (normalUnreadNotifications.length > 0) {
      markNotificationsRead(normalUnreadNotifications).then(
        this.getNotifications
      );
    }
  };

  archiveNotification = (id: string) => {
    archiveNotifications(id).then(this.getNotifications);
  };

  getNotificationsAccessToken = async (): Promise<string> => {
    const { notificationsAccessToken, notificationsIsFirstTimeConnection } =
      this.state;

    if (notificationsIsFirstTimeConnection) {
      this.setState({ notificationsIsFirstTimeConnection: false });
      return notificationsAccessToken;
    }

    const { accessToken } = await getSignalrNegotiationResult();
    return accessToken;
  };

  render() {
    const { data, notificationsUrl } = this.state;

    if (!data || !notificationsUrl) {
      return null;
    }

    return (
      <ApNotifications
        data={data}
        archive={this.archiveNotification}
        afterHide={this.markNotificationsAsRead}
        fetch={this.getNotifications}
        url={notificationsUrl}
        accessTokenFactory={this.getNotificationsAccessToken}
      />
    );
  }
}
